export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./jackpot-win.vue?vue&type=template&id=fc4af9d8"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/jackpots/jackpot-win/jackpot-win.vue?vue&type=template&id=fc4af9d8
// module id = JpAc
// module chunks = 0